import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const drorTrades: SeasonTrades[] = [
    {
        season: "2019/20",
        allTrades: [
          {
            otherTeam: manager.yevgeny,
            sentAway: "Jeff Teague",
            gotInReturn: "Rui Hachimura"
          },
          {
            otherTeam: manager.yevgeny,
            sentAway: "Jamal Murray",
            gotInReturn: "Kevin Love"
          },
          {
            otherTeam: manager.mati,
            sentAway: "Kevin Love",
            gotInReturn: "Steven Adams and Will Barton"
          },
          {
            otherTeam: manager.yevgeny,
            sentAway: "Steven Adams",
            gotInReturn: "Kevin Huerter and Dennis Schroder"
          }
          
        ]
      },
      {
        season: "2020/21",
        allTrades: [
          {
            otherTeam: manager.yevgeny,
            sentAway: "Kawhi Leonard",
            gotInReturn: "Kyrie Irving and Cole Anthony"
          },
          {
            otherTeam: manager.mati,
            sentAway: "Duncan Robinson and Seth Curry",
            gotInReturn: "Kemba Walker and Evan Fournier"
          }
    
        ]
      },
      {
        season: "2021/22",
        allTrades: [
          {
            otherTeam: manager.mati,
            sentAway: "Norman Powell",
            gotInReturn: "LeBron James and Nicolas Batum",
            amongBestTrades: true
          },
          {
            otherTeam: manager.mati,
            sentAway: "Russell Westbrook",
            gotInReturn: "Harrison Barnes and Mike Conley",
          },
          {
            otherTeam: manager.yevgeny,
            sentAway: "Mike Conley",
            gotInReturn: "Ayo Dosunmu"
          },
        ]
      }
]